<div class="size radius main-gradient" #container>
  <img [src]="image" class="size radius secondary-gradient"/>
</div>
